import { useState } from "react";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { Button, Icon, Modal, ModalTitle } from "@webtypen/react-components";
import { ContractShiftEdit } from "./ContractShiftsEdit";

export const ContractShiftsEditButton = ({ label, onSave, ...rest }) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => {
        setIsOpen(!isOpen);
    };

    return (
        <>
            {isOpen ? (
                <Modal
                    open={true}
                    onCloseRequest={toggle}
                    contentAttributes={{
                        style: {
                            maxWidth: 550,
                            margin: "auto",
                            display: "flex",
                            maxHeight: "95vh",
                            flexDirection: "column",
                        },
                    }}
                >
                    <ModalTitle>
                        <Button type="button" onClick={toggle} light className="float-right">
                            <Icon icon={faTimes} />
                        </Button>
                        <h1>Schicht-Typen verwalten</h1>
                    </ModalTitle>
                    <ContractShiftEdit onSave={onSave} />
                </Modal>
            ) : null}

            <Button type="button" {...rest} onClick={toggle}>
                {label ? label : "Schicht-Typen verwalten"}
            </Button>
        </>
    );
};
